import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { ActiveAuthenticationStateService } from '@auth-n/state/active-authentication.state-service';
import { LoggingService } from '@logging/logging.service';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { ActiveSecurityContextStateService } from '../active-security/active-security-context.state-service';

@Injectable({ providedIn: 'root' })
export class BulkImportPayrollUserRouteGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationState: ActiveAuthenticationStateService,
    private securityStateService: ActiveSecurityContextStateService,
    private logger: LoggingService
  ) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.securityStateService.fetchingActiveUser$.pipe(
      filter((fetching) => fetching === false),
      take(1),
      map(() => {
        if (!this.authenticationState.isAuthenticated) {
          return false;
        }

        const mode = next.data['mode'];

        if (mode === 'group') {
          if (!this.securityStateService.hasOrganisationAuthorityTo('AccessGroups')) {
            this.logger.trace('BulkImportPayrollUserRouteGuard: non-group user blocked from group bulk import');
            return this.router.parseUrl('forbidden');
          }
          return true;
        }

        // The hub is open to group users too (unlike the payroll-scoped routes below), so this guard
        // simply allows it; the import-type permission is enforced by OrganisationAuthorisedRouteGuard
        // on the route (BULK_IMPORT_PERMISSIONS), which does the idiomatic forbidden/no-permissions mapping.
        if (mode === 'hub') {
          return true;
        }

        if (this.securityStateService.isGroupUser()) {
          this.logger.trace('BulkImportPayrollUserRouteGuard: group user blocked from bulk import');
          return this.router.parseUrl('forbidden');
        }

        return true;
      })
    );
  }
}
